import React from 'react';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import Content from './Content';

const ContentWithContext = (props) => {
  const {
    pageContentCollection,
    setPageContentCollection,
  } = usePageContentContext();

  return <Content {...props} collection={pageContentCollection} setCollection={setPageContentCollection} />;
};

export default ContentWithContext;
